import React from 'react';
import spinner from '../assets/images/spinner.gif';

const Spinner = () => (
  <div className="pt-5">
    <img
      src={spinner}
      style={{ width: '200px', margin: 'auto', display: 'block' }}
      alt="Loading..."
    />
  </div>
);

export default Spinner;